import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import CopyButton from './copy-button'
import {  NFormItem, NInput, NInputNumber, NSelect, NForm, NCard, NButton } from 'naive-ui'
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";
import ResultLinkButton from '@/components/result-link-button'
import helper from "@/helper";


createApp({
    components: { NFormItem, NInput, NInputNumber, NSelect, NForm, CopyButton, NCard, EmbedCode, ResultLinkButton, NButton },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            percentOf: {
                percent: null,
                of: null
            },
            diff: {
                val1: null,
                val2: null
            },
            change: {
                value: null,
                direction: 'increase',
                percent: null
            },
            yOfX: {
                y: null,
                x: null
            }
        }
    },
    mounted(){
        const hashData = helper.extractDataFromURLHash();
        if (hashData) {
            helper.initFromHashData(this, hashData, (v, k) => {
                if (k === 'change.direction') {
                    return v.toString().substr(0, 8)
                }
                return Number(v);
            });
            helper.scrollToElement(hashData.a);
        }
    },
    computed: {
        percentOfResult() {
            if (!this.percentOf.percent || !this.percentOf.of) {
                return null;
            }
            return this.percentOf.percent*(this.percentOf.of/100);
        },
        diffResult() {
            if (!this.diff.val1 || !this.diff.val2) {
                return null;
            }
            if (this.diff.val1 == this.diff.val2) {
                return '0%';
            }
            const increase = Math.abs(this.diff.val1 - this.diff.val2)/this.diff.val1*100;
            return (this.diff.val1 < this.diff.val2 ? '+' : '-') + increase + '%';
        },
        changeResult() {
            if (!this.change.value || !this.change.percent) {
                return null;
            }
            const diff = this.change.value*this.change.percent/100//this.change.percent/(this.change.value/100);
            return this.change.direction === 'increase' ? this.change.value + diff : this.change.value - diff;
        },
        yOfXResult() {
            if (!this.yOfX.y || !this.yOfX.x) {
                return null;
            }
            return ((this.yOfX.y/this.yOfX.x)*100) + '%';
        }
    }
}).mount('#app')
